import { Stack, Typography } from '@mui/material'
import { InfoBubble } from '~/@ui/info-bubble/InfoBubble'
import { GraphSummary } from '../../opportunity-detail/GraphSummary'
import { calculateInvestmentProjections } from '~/@ui/chart/_utils/investmentCalculator'
import Chart from '~/@ui/chart/Chart'

type Props = {
  series: ReturnType<typeof calculateInvestmentProjections>
  slug: string
  className?: string
}

export const Graph = ({ series, slug, className = '' }: Props) => {
  const isSavingsRetirement = slug === 'zabezpecenie-financii-na-dochodok'

  return (
    <Stack className={`p-4 bg-zBlack300 rounded-4d ${className}`}>
      <Stack className="flex-row gap-1">
        <InfoBubble text="Graf ukazuje, ako sa vaša investícia vyvíja v čase." />
        <Typography className="text-base font-bold text-zWhite200">
          Graf výnosov
        </Typography>
      </Stack>

      <Stack className="relative mt-4 border border-zGrey300 rounded-t-2d">
        <Chart series={series} months={30 * 12} slug={slug} />

        <GraphSummary
          className="z-10"
          bonaship={series.bonashipValue[360] || 0}
          cash={series.cashValue[360] || 0}
          months={360}
          intPerAnn={series.rates.bonaship}
          earlyWithdraw={0}
          inflation={0}
          bankSavings={series.bankSavingsValue[360] || 0}
          slug={slug}
        />
      </Stack>

      <Stack className="bottom-[0px] w-full flex-row justify-between mt-2.5">
        <Typography className="text-xs font-medium text-zGrey400">
          0 rokov
        </Typography>
        <Typography className="text-xs font-medium text-zGrey400">
          {isSavingsRetirement ? 20 : 15} rokov
        </Typography>
        <Typography className="text-xs font-medium text-zGrey400">
          {isSavingsRetirement ? 40 : 30} rokov
        </Typography>
      </Stack>
    </Stack>
  )
}
